import { fetchSanctionStatus } from "@services/index";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useAccount } from "wagmi";

const useSanction = () => {
  const { address } = useAccount();

  const { data } = useQuery({
    queryKey: ["sanctionStatus", address],
    queryFn: async () => {
      const response = await fetchSanctionStatus(address as string);
      return response;
    },
    enabled: !!address,
    staleTime: 60_000, // 60 seconds
  });

  const isSanctioned = useMemo(() => {
    return data?.isSanctioned ?? false;
  }, [data]);

  return { isSanctioned };
};

export default useSanction;
